/**
 * @ngdoc directive
 * @module components.calendar
 * @name components.calendar:calendar
 * @scope
 * @restrict E
 * @description
 * A calendar widget that can be connected to external javascript logic.
 * @param {number=} month The month the calendar will start on. Defaults to the current month if left empty.
 * @param {number=} year The year the calendar will start on. Defaults to the current year if left empty.
 * @param {array=} events Array of days that have events for the selected month. Used to add styles for those days and to provide callback when one of those days is clicked.
 * @param {function=} onMonthChange Callback that is triggered when the month changes. Passes the following information to the function
 * - month: the month the calendar is changing to (1-12)
 * - year: the year the calendar is changing to
 * @param {function=} onEventClick Callback function that's triggered when a day with an event is clicked. Passes the following information to the function
 * - month: the month the clicked event belongs to (1-12)
 * - year: the year the clicked event belongs to
 * - day: the day of the clicked event (1-31)
 * @example
    <example module="dataExample">
        <file name="index.html">
            <div ng-controller="exampleController">
                <calendar events="eventDays" on-month-change="updateMonth(month, year)" on-event-click="reportDay(day, month, year)"></calendar>
            </div>
        </file>
        <file name="script.js">
            (function() {
                angular.module('dataExample', ['components.calendar'])
                    .controller('exampleController', exampleController);

                exampleController.$inject = ['$scope'];
                function exampleController($scope) {
                    $scope.eventDays = [1, 5, 22];
                    $scope.updateMonth = function(month, year) {
                        alert('The month is now '  + month + '/' + year + '.');
                    }

                    
                    $scope.reportDay = function(day, month, year) {
                        alert('You clicked on the event for ' + month + '/' + day + '/' + year + '.');
                    }
                }
            })();
        </file>
    </example>
 */

(function () {
    angular.module('components.calendar', [])
        .component('calendar', {
            bindings: {
                //parentDate: '<?',
                month: '<?',
                year: '<?',
                events: '<?',
                onInit: '&?',
                onMonthChange: '&?',
                onEventClick: '&?'
            },
            templateUrl: '/angular/components/calendar/calendar.html',
            controller: calendarController
        });

    function calendarController() {
        var ctrl = this;
        ctrl.$onInit = function () {
            ctrl.today = new Date();
            ctrl.today.setHours(0, 0, 0, 0);
            if (!ctrl.month) {
                ctrl.month = ctrl.today.getMonth();
            }
            if (!ctrl.year) {
                ctrl.year = ctrl.today.getFullYear();
            }
            ctrl.date = ctrl.month ? new Date(ctrl.year, ctrl.month) : new Date(ctrl.today.getFullYear(), ctrl.today.getMonth());
            ctrl.calendar = {
                week: ['S', 'M', 'T', 'W', 'Th', 'F', 'Su'],
                outerStart: [],
                outerEnd: [],
                days: []
            }
            ctrl.$$generateCalendar();
            if (ctrl.onInit) {
                ctrl.onInit({
                    ctrl: ctrl
                });
            }
        }

        ctrl.$onChanges = function (changes) {
            //console.info('$onChanges');
            //console.info(changes.parentDate);            
            //if (changes.parentDate) {
            //    ctrl.goToMonth(changes.parentDate.currentValue.getFullYear(), changes.parentDate.currentValue.getMonth());
            //}
            if (changes.month || changes.year) {
                ctrl.goToMonth(changes.year ? changes.year.currentValue : ctrl.year, changes.month ? changes.month.currentValue : ctrl.month);
            }
            if (changes.events && ctrl.calendar) {
                for (var i = 0; i < ctrl.calendar.days.length; i++) {
                    ctrl.calendar.days[i].event = ctrl.events && ctrl.events.indexOf(i + 1) > -1;
                }
            }
        }

        ctrl.$$daysInMonth = function(year, month) {
            return new Date(year, month + 1, 0).getDate();
        }

        ctrl.$$generateCalendar = function () {
            ctrl.inCurrentMonth = ctrl.today.getMonth() === ctrl.month && ctrl.today.getFullYear() === ctrl.year;
            var pos = ctrl.date.getDay();
            ctrl.calendar.outerStart = [];
            var outerDays = ctrl.$$daysInMonth(ctrl.year, ctrl.month - 1);
            for (var i = 0; i < pos; i++)
                ctrl.calendar.outerStart[i] = outerDays - pos + i + 1;
            var currentDays = ctrl.$$daysInMonth(ctrl.year, ctrl.month);
            ctrl.calendar.days.splice(Math.min(currentDays, ctrl.calendar.days.length) - 1, ctrl.calendar.days.length - currentDays);
            for (var i = 0; i < currentDays; i++) {
                var day = i + 1;
                var d = ctrl.calendar.days[i];
                ctrl.calendar.days[i] = {
                    today: ctrl.inCurrentMonth && ctrl.today.getDate() === day,
                    event: ctrl.events && ctrl.events.indexOf(day) > -1
                }
            }
            var daysAfter = 7 - (new Date(ctrl.year, ctrl.month, currentDays + 1)).getDay();
            ctrl.calendar.outerEnd = [];
            if (daysAfter < 7) {
                for (var i = 0; i < daysAfter; i++)
                    ctrl.calendar.outerEnd[i] = i + 1;
            }
        }

        /**
         * @ngdoc method
         * @name pagination#goToMonth
         * @methodOf components.calendar:calendar
         * @kind function
         * @description
         * Moves the calendar to the desired month.
         * @param {string} year The year to go to.
         * @param {object} month The month to go to.
         */
        ctrl.goToMonth = function (year, month) {
            if (ctrl.year == year && ctrl.month == month) return;
            //console.info('goToMonth');
            if (year !== undefined && month !== undefined) {
                if (month > -1 && month < 12) {
                    for (var i = 0; i < ctrl.calendar.days.length; i++) {
                        ctrl.calendar.days[i].event = ctrl.events && ctrl.events.indexOf(i + 1) > -1;
                    }
                    ctrl.year = year;
                    ctrl.month = month;
                    ctrl.date = new Date(ctrl.year, ctrl.month);
                    ctrl.$$generateCalendar();
                    if (ctrl.onMonthChange) {
                        ctrl.onMonthChange({
                            year: ctrl.year,
                            month: ctrl.month + 1
                        });
                    }
                }
                else {
                    console.log('Month out of range');
                }
            }
        }

        /**
         * @ngdoc method
         * @name pagination#prevMonth
         * @methodOf components.calendar:calendar
         * @kind function
         * @description
         * Moves the calendar to the previous month.
         */
        ctrl.prevMonth = function () {
            var month = ctrl.month;
            var year = ctrl.year;

            month--;
            if (month < 0) {
                year--;
                month = 11;
            }
            ctrl.goToMonth(year, month);
        }

        /**
         * @ngdoc method
         * @name pagination#next
         * @methodOf components.calendar:calendar
         * @kind function
         * @description
         * Moves the calendar to the next month.
         */
        ctrl.nextMonth = function () {
            var month = ctrl.month;
            var year = ctrl.year;

            month++;
            if (month > 11) {
                year++;
                month = 0;
            }
            ctrl.goToMonth(year, month);
        }

        ctrl.handleEventClick = function (day) {
            if (ctrl.calendar.days[day].event && ctrl.onEventClick) {
                ctrl.onEventClick({
                    day: day + 1,
                    month: ctrl.month + 1,
                    year: ctrl.year
                });
            }
        }
    }
})();